import { MeetingAttendance } from '@docentecas/app/store/attendances/attendances.model';

export class AddActiveMeetingAttendance {
  static readonly type = '[Attendance] Add an attendant to an actual meeting';
  constructor(public action: MeetingAttendance) {}
}
